/* unplugin-vue-components disabled */import script from "./FilePreviewDialog.vue?vue&type=script&setup=true&name=FilePreviewDialog&lang=js"
export * from "./FilePreviewDialog.vue?vue&type=script&setup=true&name=FilePreviewDialog&lang=js"

import "./FilePreviewDialog.vue?vue&type=style&index=0&id=796b4569&lang=scss"

const __exports__ = script;

export default __exports__